import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { TprFilesApiService } from '.././tpr-show-files-modal.service';


@Component({
   selector: 'tpr-add-files-modal',
   templateUrl: './tpr-add-files-modal.template.html',
   styleUrls: ['../../../../tprecm.style.scss', './tpr-add-files-modal.scss']
})
export class TprAddFilesModalComponent {

   uploading = false;

   uploadedFiles: File[] = [];

   constructor(
      private readonly toastr: ToastrService,
      public readonly dialog: MatDialogRef<TprAddFilesModalComponent>,
      private readonly service: TprFilesApiService,
      @Inject(MAT_DIALOG_DATA) public data: any
   ) { }

   onUpload(event) {
      this.uploadedFiles = event.files;

      const formData = new FormData();
      this.uploadedFiles.forEach((elem) => {
         formData.append('file', elem, elem.name);
      });

      this.uploading = true;

      this.service.uploadTprFile(this.data.tprToolId, this.data.selectedFolder, formData)
         .pipe(finalize(() => this.uploading = false))
         .subscribe(
            response => {
               this.toastr.success('Successfully uploaded file(s)');
               this.dialog.close(true);
            },
            error => this.toastr.error('Error uploading file(s)'));
   }
}
